/* eslint-disable react-hooks/exhaustive-deps */
import { CustomInput, CustomModal, CustomTextArea } from "#components";
import { addCropInitialValues } from "#validations/initialValues.js";
import { addCropValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import ReactSelector from "../../../components/ReactSelector";
import { numberOnly } from "#utils/helpers.js";

const AddCropModel = ({
  openCrop,
  onClose,
  selectedCrop,
  cropOptions,
  isCropLoading,
  renderModalData,
  cropDetail,
  getSelectedCrop,
  setSelectedCrop,
  setSelectedField,
  setSelectedSubfields,
  selectedFieldId,
  selectedSubfields,
  setFieldValue,
  values,
  setSelectedFieldId,
  parentIndex,
  selectedField,
}) => {
  const {
    values: cropValues,
    errors: cropErrors,
    touched: cropTouched,
    handleBlur: cropHandleBlur,
    handleChange: cropHandleChange,
    handleSubmit: cropHandleSubmit,
    setFieldValue: cropSetFieldValue,
    resetForm: cropResetForm,
    setValues: cropSetValues,
  } = useFormik({
    initialValues: addCropInitialValues,
    validationSchema: addCropValidationSchema,
    onSubmit: async (value) => {
      if (openCrop.add) {
        if (cropValues.acres === "Fields" && selectedField.length === 0) {
          toast.dismiss();
          toast.error("Select at least one field to proceed!");
          return;
        }
        const newCrop = {
          ...cropValues,
          soilTest: { N: "", P: "", K: "", S: "" },
          fertility: [
            {
              products: [
                {
                  soilTest: { N: "", P: "", K: "", S: "" },
                  rate: "",
                  actualValue: "",
                },
              ],
              actualTotalValue: "",
              placement: "Placement 1",
            },
          ],
          totalFertilizerNutrients: "",
          totalNutrients: "",
          cropProtection: [
            { cropTitle: "Seed Treatment", cropDetail: [] },
            { cropTitle: "Inoculant", cropDetail: [] },
            { cropTitle: "Pre-Seed Herbicide", cropDetail: [] },
            { cropTitle: "In - Crop Herbicide", cropDetail: [] },
            { cropTitle: "PGRs/Foliar Fertilizer/Biologicals", cropDetail: [] },
            { cropTitle: "Fungicides", cropDetail: [] },
            { cropTitle: "Pre Harvest/ Harvest Aids", cropDetail: [] },
          ],
          seed: { variety: "", rate: "", unit: "", quantity: "" },
        };
        setFieldValue("data", [...values.data, newCrop]);

        onClose("add");
        cropResetForm();
        setSelectedSubfields([]);
        setSelectedFieldId([]);
        setSelectedField([]);
      } else if (openCrop.edit) {
        if (cropValues.acres === "Fields" && selectedField.length === 0) {
          toast.dismiss();
          toast.error("Select at least one field to proceed!");
          return;
        }
        if (parentIndex !== undefined) {
          const updatedData = [...values.data]; // Copy the data array

          // Update the crop at parentIndex with new crop values
          updatedData[parentIndex] = {
            ...updatedData[parentIndex],
            cropId: cropValues.cropId,
            fieldId: cropValues.fieldId,
            subFieldIds: cropValues.subFieldIds,
            variety: cropValues.variety,
            acres: cropValues.acres,
            acresValue: cropValues.acresValue,
            description: cropValues.description,
            fieldData: cropValues.fieldData,
          };

          setFieldValue("data", updatedData);
        }
        onClose("edit");
        cropResetForm();
      }
    },
  });

  const handelSelectedCrop = (value) => {
    cropSetFieldValue("cropId", value?.id);
    cropSetFieldValue("cropName", value?.label);
    setSelectedCrop(value);
  };
  useEffect(() => {
    if (openCrop.edit) {
      cropSetValues({
        acres: cropDetail?.acres,
        acresValue: cropDetail?.acresValue,
        cropId: cropDetail?.cropId,
        description: cropDetail?.description,
        fieldId: cropDetail?.fieldId,
        subFieldIds: cropDetail?.subFieldIds,
        variety: cropDetail?.variety,
        fieldData: cropDetail?.fieldData,
      });
      setSelectedCrop(getSelectedCrop(cropDetail?.cropId));
      setSelectedSubfields(cropDetail?.subFieldIds);
      setSelectedField(cropDetail?.fieldData);
      setSelectedFieldId(cropDetail?.fieldId);
    }
  }, [openCrop.edit]);

  useEffect(() => {
    if (!openCrop.add && !openCrop.edit) {
      cropResetForm();
      setSelectedCrop("");
    }
  }, [openCrop.add, openCrop.edit]);

  useEffect(() => {
    cropSetFieldValue("fieldId", selectedFieldId);
    cropSetFieldValue("subFieldIds", selectedSubfields);
    cropSetFieldValue("fieldData", selectedField);
  }, [selectedFieldId, selectedSubfields, selectedField]);

  return (
    <CustomModal
      open={openCrop?.add || openCrop.edit}
      title={openCrop?.add ? "Add Crop" : "Edit Crop"}
      actionButtonTitle={openCrop?.add ? "Save" : "Update"}
      onClose={() => onClose(openCrop?.add ? "add" : "edit")}
      onSubmit={cropHandleSubmit}
      loading={false}
      bodyClass="modal-body p-0 border_structure"
    >
      <div className="common-modal-form">
        <div className="row">
          <ReactSelector
            label="Crop"
            options={cropOptions}
            name="cropId"
            placeholder="Select"
            value={selectedCrop}
            isLoading={isCropLoading}
            onChange={handelSelectedCrop}
            error={cropErrors?.cropId}
            onBlur={cropHandleBlur}
            touched={cropTouched?.cropId}
          />

          <div className="col-xl-6">
            <div className="sub_fields_item">
              <CustomInput
                label="Variety"
                type="text"
                name="variety"
                placeholder="Enter variety"
                value={cropValues.variety}
                onChange={cropHandleChange}
                onBlur={cropHandleBlur}
                error={cropErrors.variety}
                touched={cropTouched.variety}
              />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <h4 className="h3">Acres </h4>
        </div>
        <div className="d-flex justify-content-start align-items-center gap-5 my-3">
          {["Values", "Fields"].map((label, idx) => (
            <div
              className="radio_label d-flex justify-content-start align-items-center gap-2"
              key={idx}
            >
              <input
                type="radio"
                name="acres"
                id={`radio-${label}`}
                value={label}
                onChange={(e) => {
                  cropSetFieldValue("acres", e.target.value);

                  if (e.target.value === "Fields") {
                    cropSetFieldValue("acresValue", "");
                  } else {
                    cropSetFieldValue("fieldId", "");
                    cropSetFieldValue("subFieldIds", []);
                    setSelectedFieldId([]);
                    setSelectedSubfields([]);
                    setSelectedField([]);
                  }
                }}
                checked={cropValues.acres === label}
              />
              <label htmlFor={`radio-${label}`}></label>
              <span className="fw-medium">{label}</span>
            </div>
          ))}
        </div>
        {cropValues.acres === "Values" ? (
          <div className="col-xl-6">
            <div className="sub_fields_item">
              <CustomInput
                label="Enter Acres"
                type="text"
                name="acresValue"
                placeholder="Enter Acres"
                value={cropValues.acresValue}
                onChange={cropHandleChange}
                onBlur={cropHandleBlur}
                onKeyPress={numberOnly}
                error={cropErrors.acresValue}
                touched={cropTouched.acresValue}
              />
            </div>
          </div>
        ) : (
          renderModalData(cropValues.cropId)
        )}

        <div className="mt-3">
          <CustomTextArea
            label="Description"
            placeholder="Enter description here"
            name="description"
            value={cropValues?.description}
            onChange={cropHandleChange}
            touched={cropTouched?.description}
            error={cropErrors?.description}
            onBlur={cropHandleBlur}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default AddCropModel;
